package com.essntl.core.utils.viewmodel

data class PaginationState<T>(
    val isLoading: Boolean = false,
    val isFailure: Boolean = false,
    val isSuccess: Boolean = false,
    val isLastPage: Boolean = false,
    val loadedPages: Int = 0,
    val query: String = "",
    val data: List<T> = emptyList(),
    val error: Throwable? = null,
) {
    /**
     * Determines if there are more items available to load.
     *
     * @return true if there are more items to load, false otherwise
     */
    val hasMore: Boolean
        get() = !isLastPage

    fun loading() = copy(isLoading = true)

    fun failure(error: Throwable? = null) =
        copy(
            isFailure = true,
            isLoading = false,
            error = error,
        )

    fun success(data: List<T>) =
        copy(
            isSuccess = true,
            isLoading = false,
            data = this.data + data,
            isLastPage = data.isEmpty(),
            loadedPages = loadedPages + 1,
        )

    companion object {
        fun <T> initial() = PaginationState<T>()

        fun <T> loading(state: PaginationState<T>? = null) =
            state
                ?.loading()
                ?: PaginationState(isLoading = true)

        fun <T> failure(state: PaginationState<T>? = null, error: Throwable? = null) =
            state
                ?.failure(error)
                ?: PaginationState(isFailure = true, error = error)
    }
}
